export const SituacaoParcelaEnum = {
  PENDENTE: 'pendente',
  RENEGOCIADA: 'renegociada'
}
